import React from 'react'
import style from './TableCellIconMap.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next/src'

export default function TableCellIconMap(props) {
  const [t] = useTranslation()

  let { iconMap, value } = props

  let className =
    iconMap[value] && iconMap[value].class && style[iconMap[value].class]

  return (
    <span className={className}>
      {iconMap[value] && iconMap[value].tooltip && (
        <p className={style.tooltip}>{t(iconMap[value].tooltip)}</p>
      )}
      {iconMap[value] && iconMap[value].icon && (
        <FontAwesomeIcon icon={iconMap[value].icon} />
      )}
    </span>
  )
}
